// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-operation-monitoring.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-operation-monitoring',
  title: 'Monitor AI systems in production and retain AI event logs',
  description:
    'Confirm that AI systems in production are continuously monitored for performance, drift, bias, safety, misuse and security events (ISO/IEC 42001 Annex A.6.2.6) and that automatically generated event logs are retained and protected to a level consistent with the risk of the AI system and legal obligations (Annex A.6.2.8). Logs shall be reviewed to detect anomalies and to support post-market monitoring, investigations and audits. Review the AI-monitoring configuration and the log-review records.',
  category: 'technical',
  scfIds: ['SCF-AIG-007'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI monitoring and logging standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
